import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MailIcon, PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function ProposalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 md:py-32 bg-gradient-to-b from-white to-[#F8F9FA]" ref={ref} data-id="element-198">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-200">
          <img src="https://cdn.magicpatterns.com/uploads/rPECazqhHrWF2aBnEWg3gz/beclinical_logo_2.svg" alt="Be Clinical" className="h-16 w-auto mx-auto mb-8 opacity-30" data-id="element-201" />

          <h2 className="text-3xl md:text-5xl font-light text-[#1B2A4A] mb-6" data-id="element-202">
            Ready to get started?
          </h2>

          <p className="text-xl text-[#666] mb-12" data-id="element-203">
            Reach out to{' '}
            <span className="text-[#1B2A4A] font-medium" data-id="element-204">Josh</span> or{' '}
            <span className="text-[#1B2A4A] font-medium" data-id="element-205">Noah</span> at LetLois
            anytime.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-206">
          <a href="mailto:hello@letlois.com" className="group flex items-center gap-3 bg-[#1B2A4A] text-white px-8 py-4 rounded-full font-medium hover:bg-[#2A3F6A] transition-colors" data-id="element-207">
            <MailIcon className="w-5 h-5" data-id="element-208" />
            Get in Touch
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-209" />
          </a>

          <a href="tel:+1234567890" className="flex items-center gap-3 bg-white text-[#1B2A4A] px-8 py-4 rounded-full font-medium border-2 border-[#1B2A4A]/10 hover:border-[#C9A96E] hover:text-[#C9A96E] transition-colors" data-id="element-210">
            <PhoneIcon className="w-5 h-5" data-id="element-211" />
            Schedule a Call
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-20 pt-8 border-t border-[#1B2A4A]/10" data-id="element-212">
          <p className="text-sm text-[#666]" data-id="element-213">
            Prepared by{' '}
            <span className="font-semibold text-[#1B2A4A]" data-id="element-214">LetLois</span> •
            February 2026
          </p>
          <p className="text-xs text-[#A8B4C4] mt-2" data-id="element-215">
            This proposal is confidential and intended solely for Be Clinical
            Med Spa.
          </p>
        </motion.div>
      </div>
    </section>;
}